<script lang="ts">const { title = 'Square' } = $props();
</script>

<svg
  class="LogoJewel"
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 994.6 995.7"
  width="22"
  height="22"
>
  <path
    fill="black"
    d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
    c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
    c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
    c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
    H391.8z"
  />
</svg>
<span class="text">{title}</span>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.LogoJewel {
  display: block;
  width: 22px;
  min-width: 22px;
  max-width: 22px;
  height: 22px;
  min-height: 22px;
  max-height: 22px;
}

[fill] {
  fill: var(--color-text, var(--color-neutral-000, #000000));
}

.text {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}</style>
